/* SkinPatch theme behaviour — reveals, FAQ, signature dot, AJAX cart drawer. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal on scroll ---------- */
  function initReveals() {
    var els = document.querySelectorAll('.reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries
          .filter(function (e) {
            return e.isIntersecting;
          })
          .forEach(function (e, i) {
            e.target.style.transitionDelay = Math.min(i, 4) * 60 + 'ms';
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );
    els.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq() {
    document.querySelectorAll('.faq__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq__item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- signature: flare <-> sealed ---------- */
  function initSignature() {
    var sig = document.querySelector('.signature');
    if (!sig || reduce) return;
    var timer = null;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !timer) {
            timer = setInterval(function () {
              sig.classList.toggle('is-sealed');
            }, 2200);
          } else if (!e.isIntersecting && timer) {
            clearInterval(timer);
            timer = null;
          }
        });
      },
      { threshold: 0.3 }
    );
    io.observe(sig);
  }

  /* ---------- cart ---------- */
  var money = function (cents) {
    var f = window.SKINPATCH_MONEY_FORMAT || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return f.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };

  function drawer() {
    return document.getElementById('cart-drawer');
  }

  function setCartExpanded(open) {
    document.querySelectorAll('[data-cart-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function openDrawer() {
    var d = drawer();
    if (d) {
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setCartExpanded(true);
    }
  }

  function closeDrawer() {
    var d = drawer();
    if (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setCartExpanded(false);
    }
  }

  function renderCart(cart) {
    var count = document.querySelectorAll('[data-cart-count]');
    count.forEach(function (el) {
      var prev = el.dataset.count;
      el.textContent = cart.item_count;
      el.dataset.count = cart.item_count;
      if (prev !== undefined && prev !== String(cart.item_count) && cart.item_count > 0) {
        el.classList.remove('bump');
        void el.offsetWidth;
        el.classList.add('bump');
      }
    });

    var body = document.querySelector('[data-cart-lines]');
    var foot = document.querySelector('[data-cart-total]');
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML =
        '<div style="text-align:center;padding-block:3rem">' +
        '<p class="measure" style="font-size:11px;color:var(--muted-fg)">Your cart is empty.</p>' +
        '<a href="/#shop" class="btn btn--ghost btn--block" style="margin-top:1.5rem" data-cart-close-nav>Shop the system</a>' +
        '</div>';
      if (foot) foot.textContent = money(0);
      return;
    }

    body.innerHTML = cart.items
      .map(function (it) {
        var img = it.image
          ? '<img src="' + it.image.replace(/(\.[^.]*)$/, '_160x$1') + '" alt="">'
          : '<div style="width:64px;height:80px;background:var(--trace)"></div>';
        return (
          '<div class="line">' +
          img +
          '<div style="flex:1">' +
          '<div class="rowbetween"><span style="font-size:14px;font-weight:500">' +
          it.product_title +
          '</span><span class="measure" style="font-size:12px">' +
          money(it.final_line_price) +
          '</span></div>' +
          (it.variant_title
            ? '<span class="tag" style="display:block;margin-top:2px">' + it.variant_title + '</span>'
            : '') +
          '<div class="qty" data-key="' +
          it.key +
          '">' +
          '<button type="button" data-step="-1" aria-label="Decrease quantity">–</button>' +
          '<span>' +
          it.quantity +
          '</span>' +
          '<button type="button" data-step="1" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '</div>' +
          '</div>'
        );
      })
      .join('');

    if (foot) foot.textContent = money(cart.total_price);
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(renderCart);
  }

  function addToCart(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function () {
        return fetchCart();
      })
      .then(openDrawer);
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(renderCart);
  }

  function initCart() {
    document.addEventListener('click', function (e) {
      var add = e.target.closest('[data-add]');
      if (add) {
        e.preventDefault();
        var form = add.closest('form');
        var radio = form && form.querySelector('input[type="radio"][name="id"]:checked');
        var sel = form && form.querySelector('select[name="id"]');
        var id = (radio && radio.value) || (sel && sel.value) || add.getAttribute('data-add');
        if (!id) return;
        var label = add.innerHTML;
        add.classList.add('is-loading');
        add.textContent = 'Adding…';
        addToCart(id, 1).finally(function () {
          add.classList.remove('is-loading');
          add.innerHTML = label;
        });
        return;
      }

      if (e.target.closest('[data-cart-close-nav]')) {
        closeDrawer();
        return;
      }

      if (e.target.closest('[data-cart-open]')) {
        e.preventDefault();
        fetchCart().then(openDrawer);
        return;
      }

      if (e.target.closest('[data-cart-close]')) {
        e.preventDefault();
        closeDrawer();
        return;
      }

      var step = e.target.closest('[data-step]');
      if (step) {
        e.preventDefault();
        var wrap = step.closest('.qty');
        var key = wrap.getAttribute('data-key');
        var cur = parseInt(wrap.querySelector('span').textContent, 10) || 0;
        var next = cur + parseInt(step.getAttribute('data-step'), 10);
        if (next < 0) next = 0;
        changeLine(key, next);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    /* variant cards (PDP): live-sync price, unit price, CTA, and buy bar */
    function syncVariant(r) {
      document.querySelectorAll('.vcard').forEach(function (c) {
        var inp = c.querySelector('input[name="id"]');
        c.classList.toggle('is-selected', !!(inp && inp.checked));
      });
      var priceEl = document.querySelector('[data-price]');
      if (priceEl && r.dataset.price) priceEl.textContent = r.dataset.price;
      var unitEl = document.querySelector('[data-unit-price]');
      if (unitEl) unitEl.textContent = r.dataset.unit || '';
      var btnPrice = document.querySelector('[data-btn-price]');
      if (btnPrice && r.dataset.price) btnPrice.textContent = r.dataset.price;
      var mainAdd = document.querySelector('.pdp form [data-add]');
      if (mainAdd) mainAdd.setAttribute('data-add', r.value);
      var bbAdd = document.querySelector('[data-buybar-add]');
      if (bbAdd) bbAdd.setAttribute('data-add', r.value);
      var bbPrice = document.querySelector('[data-buybar-price]');
      if (bbPrice && r.dataset.price) bbPrice.textContent = r.dataset.price;
      var bbVar = document.querySelector('[data-buybar-variant]');
      if (bbVar && r.dataset.title) bbVar.textContent = r.dataset.title.split(' (')[0];
      var main = document.querySelector('[data-pdp-main]');
      if (main && r.dataset.img) {
        main.removeAttribute('srcset');
        main.src = r.dataset.img;
        if (r.dataset.imgAlt) main.alt = r.dataset.imgAlt;
        var base = r.dataset.img.split('&width=')[0];
        document.querySelectorAll('.pdp__thumb').forEach(function (t) {
          t.classList.toggle('is-active', (t.getAttribute('data-full') || '').split('&width=')[0] === base);
        });
      }
    }
    document.querySelectorAll('.vcard input[name="id"]').forEach(function (r) {
      r.addEventListener('change', function () {
        syncVariant(r);
      });
    });

    var vsel = document.querySelector('select[name="id"]');
    if (vsel) {
      vsel.addEventListener('change', function () {
        var opt = vsel.options[vsel.selectedIndex];
        var priceEl = document.querySelector('[data-price]');
        if (priceEl && opt && opt.dataset.price) priceEl.textContent = opt.dataset.price;
        var hidden = vsel.form && vsel.form.querySelector('input[type="hidden"][name="id"]');
        if (hidden) hidden.value = vsel.value;
        var bbAdd = document.querySelector('[data-buybar-add]');
        if (bbAdd) bbAdd.setAttribute('data-add', vsel.value);
        var bbPrice = document.querySelector('[data-buybar-price]');
        if (bbPrice && opt && opt.dataset.price) bbPrice.textContent = opt.dataset.price;
      });
    }

    fetchCart();
  }

  function boot() {
    initReveals();
    initFaq();
    initSignature();
    initCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ---------- header scrolled state ---------- */
(function () {
  var h = document.querySelector('.hdr');
  if (!h) return;
  var ticking = false;
  function update() {
    h.classList.toggle('is-stuck', window.scrollY > 8);
    ticking = false;
  }
  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    },
    { passive: true }
  );
  update();
})();

/* ---------- mobile menu ---------- */
(function () {
  var btn = document.querySelector('[data-menu-toggle]');
  var panel = document.querySelector('[data-menu-panel]');
  if (!btn || !panel) return;
  function setOpen(open) {
    panel.classList.toggle('is-open', open);
    btn.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  btn.addEventListener('click', function () {
    setOpen(!panel.classList.contains('is-open'));
  });
  panel.addEventListener('click', function (e) {
    if (e.target.closest('a') || e.target.closest('[data-menu-close]')) setOpen(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) setOpen(false);
  });
})();


/* ================= MOTION 2.0 ================= */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(pointer: fine)').matches;

  /* load choreography */
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      document.body.classList.add('is-loaded');
    });
  });

  /* scroll progress fallback where scroll-timeline is unsupported */
  if (!(window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()'))) {
    var bar = document.querySelector('.pagebar');
    if (bar) {
      var pTick = false;
      var updateP = function () {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        bar.style.setProperty('--scroll-p', max > 0 ? window.scrollY / max : 0);
        pTick = false;
      };
      window.addEventListener(
        'scroll',
        function () {
          if (pTick) return;
          pTick = true;
          requestAnimationFrame(updateP);
        },
        { passive: true }
      );
      updateP();
    }
  }

  /* count-up figures when they enter the viewport */
  if (!reduce && 'IntersectionObserver' in window) {
    var targets = document.querySelectorAll('.story__stat b, .claim__k, .specstrip dt');
    var ease = function (t) {
      return 1 - Math.pow(1 - t, 3);
    };
    var runCount = function (el) {
      var text = el.textContent.trim();
      var m = text.match(/^(\d+(?:\.\d+)?)([\s\S]*)$/);
      if (!m) return;
      var end = parseFloat(m[1]);
      if (!isFinite(end) || end === 0) return;
      var suffix = m[2];
      var decimals = (m[1].split('.')[1] || '').length;
      var t0 = null;
      var dur = 900;
      var frame = function (ts) {
        if (!t0) t0 = ts;
        var k = Math.min((ts - t0) / dur, 1);
        el.textContent = (end * ease(k)).toFixed(decimals) + suffix;
        if (k < 1) requestAnimationFrame(frame);
        else el.textContent = text;
      };
      requestAnimationFrame(frame);
    };
    var cio = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            runCount(e.target);
            cio.unobserve(e.target);
          }
        });
      },
      { threshold: 0.6 }
    );
    targets.forEach(function (el) {
      cio.observe(el);
    });
  }

  /* ruler ticks lean toward the cursor */
  if (!reduce && finePointer) {
    document.querySelectorAll('.ruler').forEach(function (ruler) {
      var ticks = null;
      var raf = false;
      var mx = null;
      var apply = function () {
        raf = false;
        if (!ticks) {
          ticks = Array.prototype.map.call(ruler.querySelectorAll('i'), function (t) {
            var r = t.getBoundingClientRect();
            return { el: t, x: r.left + r.width / 2 };
          });
        }
        ticks.forEach(function (t) {
          if (mx === null) {
            t.el.style.transform = '';
            return;
          }
          var d = Math.abs(mx - t.x);
          var f = Math.max(0, 1 - d / 70);
          t.el.style.transform = f > 0.02 ? 'scaleY(' + (1 + 1.6 * f * f) + ')' : '';
        });
      };
      var queue = function () {
        if (!raf) {
          raf = true;
          requestAnimationFrame(apply);
        }
      };
      ruler.addEventListener('mousemove', function (e) {
        mx = e.clientX;
        queue();
      });
      ruler.addEventListener('mouseleave', function () {
        mx = null;
        ticks = null;
        queue();
      });
    });
  }

  /* instrument cursor chip over media */
  if (!reduce && finePointer) {
    var chip = document.createElement('div');
    chip.className = 'cursor-chip';
    chip.setAttribute('aria-hidden', 'true');
    document.body.appendChild(chip);

    document.querySelectorAll('.ig__tile').forEach(function (el) {
      el.dataset.cursor = 'Open post';
    });
    document.querySelectorAll('.pcard__media a').forEach(function (el) {
      el.dataset.cursor = 'View product';
    });
    document.querySelectorAll('.stockist').forEach(function (el) {
      el.dataset.cursor = 'Visit store';
    });

    var cx = 0;
    var cy = 0;
    var tx = 0;
    var ty = 0;
    var active = false;
    var looping = false;
    var loop = function () {
      cx += (tx - cx) * 0.22;
      cy += (ty - cy) * 0.22;
      chip.style.left = cx + 'px';
      chip.style.top = cy + 'px';
      if (active || Math.abs(tx - cx) + Math.abs(ty - cy) > 0.5) {
        requestAnimationFrame(loop);
      } else {
        looping = false;
      }
    };
    document.addEventListener('mousemove', function (e) {
      tx = e.clientX;
      ty = e.clientY;
      var over = e.target.closest && e.target.closest('[data-cursor]');
      if (over) {
        chip.textContent = over.dataset.cursor;
        if (!active) {
          cx = tx;
          cy = ty;
          chip.classList.add('is-on');
          active = true;
        }
        if (!looping) {
          looping = true;
          requestAnimationFrame(loop);
        }
      } else if (active) {
        chip.classList.remove('is-on');
        active = false;
      }
    });
  }
})();


/* ================= MOTION 2.0 — MOBILE ================= */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var coarse = window.matchMedia('(pointer: coarse)').matches;

  /* deferred background images (gallery/about tiles): load when near the viewport */
  (function () {
    var bgs = document.querySelectorAll('[data-bg]');
    if (!bgs.length) return;
    var set = function (el) { el.style.backgroundImage = 'url(' + el.getAttribute('data-bg') + ')'; el.removeAttribute('data-bg'); };
    if (!('IntersectionObserver' in window)) { bgs.forEach(set); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { set(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '600px 0px' });
    bgs.forEach(function (el) { io.observe(el); });
  })();

  /* product-card quick add: size pills update price, per-patch price and the add target */
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r.matches || !r.matches('[data-qadd] input[name="id"]')) return;
    var f = r.closest('[data-qadd]');
    var price = f.querySelector('[data-qadd-price]');
    if (price && r.dataset.price) price.textContent = r.dataset.price;
    var unit = f.querySelector('[data-qadd-unit]');
    if (unit) unit.textContent = r.dataset.unit || '';
    var btn = f.querySelector('[data-add]');
    if (btn) btn.setAttribute('data-add', r.value);
  });

  /* sticky buy bar: appears once the in-page add button scrolls away */
  var buybar = document.querySelector('[data-buybar]');
  var pdpForm = document.querySelector('.pdp form');
  if (buybar && pdpForm && 'IntersectionObserver' in window) {
    buybar.hidden = false;
    var bio = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          var below = e.boundingClientRect.top < 0;
          var on = !e.isIntersecting && below;
          buybar.classList.toggle('is-visible', on);
          /* lets the chat button step up so it never covers Add to cart */
          document.documentElement.classList.toggle('buybar-on', on);
          if (on) document.documentElement.style.setProperty('--buybar-h', buybar.offsetHeight + 'px');
        });
      },
      { threshold: 0 }
    );
    bio.observe(pdpForm);
  }

  /* touch spotlight: the tile nearest viewport centre gets the hover treatment */
  if (coarse && !reduce && 'IntersectionObserver' in window) {
    var groups = [
      { sel: '.gallery__grid', child: '.gtile', parentFlag: true },
      { sel: '.ig__grid', child: '.ig__tile', parentFlag: false },
      { sel: '.shop__grid', child: '.pcard', parentFlag: false },
      { sel: '.stockists__row', child: '.stockist', parentFlag: false },
    ];
    groups.forEach(function (g) {
      var parent = document.querySelector(g.sel);
      if (!parent) return;
      var items = parent.querySelectorAll(g.child);
      if (!items.length) return;
      var sio = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            e.target.classList.toggle('is-focus', e.isIntersecting);
          });
          if (g.parentFlag) {
            parent.classList.toggle('has-focus', !!parent.querySelector('.is-focus'));
          }
        },
        { rootMargin: '-38% 0px -38% 0px', threshold: 0 }
      );
      items.forEach(function (el) {
        sio.observe(el);
      });
    });
  }

  /* rulers respond to a finger drag as well as a cursor */
  if (coarse && !reduce) {
    document.querySelectorAll('.ruler').forEach(function (ruler) {
      var ticks = null;
      var raf = false;
      var mx = null;
      var apply = function () {
        raf = false;
        if (!ticks) {
          ticks = Array.prototype.map.call(ruler.querySelectorAll('i'), function (t) {
            var r = t.getBoundingClientRect();
            return { el: t, x: r.left + r.width / 2 };
          });
        }
        ticks.forEach(function (t) {
          if (mx === null) {
            t.el.style.transform = '';
            return;
          }
          var d = Math.abs(mx - t.x);
          var f = Math.max(0, 1 - d / 70);
          t.el.style.transform = f > 0.02 ? 'scaleY(' + (1 + 1.6 * f * f) + ')' : '';
        });
      };
      var queue = function () {
        if (!raf) {
          raf = true;
          requestAnimationFrame(apply);
        }
      };
      ruler.addEventListener(
        'touchmove',
        function (e) {
          mx = e.touches[0].clientX;
          queue();
        },
        { passive: true }
      );
      ruler.addEventListener('touchend', function () {
        mx = null;
        ticks = null;
        queue();
      });
    });
  }

  /* swipe the cart drawer closed */
  var panel = document.querySelector('.drawer__panel');
  var drawerEl = document.getElementById('cart-drawer');
  if (panel && drawerEl && coarse) {
    var startX = null;
    var dx = 0;
    panel.addEventListener(
      'touchstart',
      function (e) {
        startX = e.touches[0].clientX;
        dx = 0;
      },
      { passive: true }
    );
    panel.addEventListener(
      'touchmove',
      function (e) {
        if (startX === null) return;
        dx = Math.max(0, e.touches[0].clientX - startX);
        if (dx > 6) {
          panel.classList.add('is-dragging');
          panel.style.transform = 'translateX(' + dx + 'px)';
        }
      },
      { passive: true }
    );
    panel.addEventListener('touchend', function () {
      panel.classList.remove('is-dragging');
      panel.style.transform = '';
      if (dx > 70) {
        drawerEl.classList.remove('is-open');
        drawerEl.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        document.querySelectorAll('[data-cart-open]').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
        });
      }
      startX = null;
      dx = 0;
    });
  }
})();

/* header submenu: click toggle for touch, Escape + outside click to close */
(function () {
  'use strict';
  var groups = Array.prototype.slice.call(document.querySelectorAll('[data-subnav]'));
  if (!groups.length) return;
  function close(g) {
    g.classList.remove('is-open');
    g.querySelector('.nav__groupbtn').setAttribute('aria-expanded', 'false');
  }
  groups.forEach(function (g) {
    var btn = g.querySelector('.nav__groupbtn');
    btn.addEventListener('click', function () {
      groups.forEach(function (o) { if (o !== g) close(o); });
      var open = g.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
  document.addEventListener('click', function (e) {
    groups.forEach(function (g) { if (!g.contains(e.target)) close(g); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') groups.forEach(close);
  });
  document.querySelectorAll('[data-cbot-trigger]').forEach(function (b) {
    b.addEventListener('click', function () {
      groups.forEach(close);
      var fab = document.querySelector('[data-cbot-open]');
      if (fab) fab.click();
    });
  });
})();

/* PDP thumbnails: click to swap into the featured image */
(function () {
  'use strict';
  var featured = document.querySelector('[data-pdp-main]') || document.querySelector('.pdp__media > img');
  var thumbs = document.querySelectorAll('.pdp__thumb');
  if (!featured || !thumbs.length) return;
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var full = t.getAttribute('data-full');
      if (!full) return;
      featured.removeAttribute('srcset');
      featured.src = full;
      if (t.alt) featured.alt = t.alt;
      thumbs.forEach(function (o) {
        o.classList.toggle('is-active', o === t);
      });
    });
  });
})();

/* Ask SKINPATCH — curated concierge. Every answer is a claim that already
   lives on this site; anything outside the brain gets routed to a human. */
(function () {
  'use strict';
  var root = document.querySelector('[data-cbot]');
  var fab = document.querySelector('[data-cbot-open]');
  if (!root || !fab || !window.CBOT_KB) return;
  var log = root.querySelector('[data-cbot-log]');
  var chipsEl = root.querySelector('[data-cbot-chips]');
  var form = root.querySelector('[data-cbot-form]');
  var input = root.querySelector('[data-cbot-input]');
  var P = window.CBOT_KB.products;

  function card(p) {
    return '<a class="cbot__card" href="' + p.url + '"><span>' + p.title + '</span><b class="measure">' + p.price + '</b></a>' +
      (p.available ? '<button type="button" class="btn btn--solid btn--sm cbot__add" data-add="' + p.variant + '">Add to cart</button>' : '');
  }

  var KB = [
    { k: ['how', 'use', 'apply', 'application', 'put', 'start', 'instructions', 'steps', 'work', 'works'],
      a: "Three steps. One: clean, fully dry skin — no serums or oils under the patch. Two: press the patch over the spot and hold a few seconds. Three: leave it 6–8 hours; the film turns white as it absorbs, and that's the proof it worked. Peel gently, don't pick.<br><a href='/pages/how-it-works'>The full system ↗</a>" },
    { k: ['long', 'hours', 'wear', 'time', 'leave', 'overnight', 'sleep', 'duration'],
      a: "Six to eight hours, then replace — overnight is ideal. Watch the patch, not the clock: when the film has turned opaque white over the spot, it has done its job.<br><a href='/blogs/journal/how-long-to-leave-a-pimple-patch-on'>How long, in detail ↗</a>" },
    { k: ['white', 'dome', 'turned', 'opaque', 'working', 'worked'],
      a: "The white dome is absorbed fluid held in the hydrocolloid — it means the patch worked. Peel it off gently and don't pick at the skin underneath." },
    { k: ['makeup', 'foundation', 'concealer', 'day', 'daytime', 'invisible', 'visible', 'show', 'hide', 'work', 'school', 'camera'],
      a: "Yes — that's exactly what Day is for: a 0.03 mm matte film with a feathered edge that disappears under daylight and makeup. Wear 6–8 hours, then replace. Apply makeup over it with light taps, never dragging.<br>" },
    { k: ['cystic', 'deep', 'underground', 'hard', 'painful', 'bump', 'blind'],
      a: "Honest answer: mostly no. Hydrocolloid drains spots that have come to a head. On a deep, closed cystic bump it protects and stops the picking, but it won't flatten what hasn't surfaced. Recurring cystic acne belongs with a dermatologist.<br><a href='/blogs/journal/do-pimple-patches-work-on-cystic-acne'>Our full honest take ↗</a>" },
    { k: ['ingredients', 'medicated', 'acid', 'salicylic', 'inside', 'made', 'material', 'hydrocolloid', 'actives', 'fragrance', 'chemical'],
      a: "Six ingredients, no actives: hydrolyzed corn starch, mineral oil, hydrogenated poly(C6-20 olefin), styrene/isoprene copolymer, polyisobutene and an antioxidant. No acids, no fragrance, nothing medicated — the mechanism is physical.<br><a href='/blogs/journal/whats-in-a-hydrocolloid-patch'>What's in it ↗</a>" },
    { k: ['sensitive', 'skin', 'types', 'safe', 'sting', 'irritate'],
      a: "There are no acids, no fragrance and no added actives. Our EU safety assessment found no fragrance allergens and doesn't expect it to irritate skin under normal use — it was assessed for adult facial skin. Avoid the eye area, and stop if irritation or redness occurs.<br><a href='/pages/science#lab'>See the lab results ↗</a>" },
    { k: ['lab', 'tested', 'testing', 'test', 'tests', 'results', 'heavy', 'metals', 'metal', 'lead', 'bacteria', 'microbe', 'microbial', 'toxic', 'toxicologist', 'gmp', 'iso', 'certified', 'quality', 'shelf', 'expire', 'expiry'],
      a: "Yes — tested by an independent third-party lab in January 2026. All 7 specified microorganisms (incl. E. coli, Salmonella, S. aureus) were not detected, and all 6 heavy metals passed. A European Registered Toxicologist then signed off an EU cosmetic safety assessment in February 2026. It's made in an ISO 22716 (cosmetics GMP) certified facility, with a 3-year shelf life. These are safety tests, not efficacy trials.<br><a href='/pages/science#lab'>See the full lab file ↗</a>" },
    { k: ['which', 'pick', 'choose', 'recommend', 'best', 'first', 'difference', 'between', 'compare', 'vs'],
      a: "Simple rule: being seen → Day (invisible under makeup). Going to sleep → Night (thicker, absorbs hardest). Not sure or covering a full breakout → start with the Combo, it carries both.<br>" + '%CARD_COMBO%' },
    { k: ['price', 'cost', 'much', 'cheap', 'expensive'],
      a: "Current prices: Night from %P_NIGHT%, Day from %P_DAY%, and the Day + Night Combo from %P_COMBO%. 12 mm patches, 12 per sheet — more patches per box at an accessible price.<br><a href='/collections/pimple-patches'>See all patches ↗</a>" },
    { k: ['combo', 'starter', 'set', 'both'],
      a: "The Combo is the best first box: one sheet of invisible Day patches for the hours you're seen, one sheet of thicker Night patches for the hours you're not.<br>" + '%CARD_COMBO%' },
    { k: ['night', 'overnight'],
      a: "Night is the flagship: a thicker hydrocolloid film built for 6–8 hours of uninterrupted wear. Press it on before bed; it draws out fluid overnight and turns white as it works.<br>" + '%CARD_NIGHT%' },
    { k: ['size', 'mm', 'count', 'many', 'sheet', 'patches', 'box'],
      a: "All formats are 12 mm patches, 12 per sheet. Boxes come in 48 and 84 patch counts — more patches per box is the whole point." },
    { k: ['shipping', 'ship', 'deliver', 'delivery', 'arrive', 'free', 'tracking'],
      a: "Free U.S. shipping on orders over $25; under that it's a flat $4. Orders ship within 1–2 business days and you get a tracking link by email.<br><a href='/pages/shipping-returns'>Shipping & returns ↗</a>" },
    { k: ['return', 'returns', 'refund', 'money', 'back', 'exchange'],
      a: "Opened boxes are sealed for hygiene and can't be restocked — but before sending anything back, write to us and a human will sort it within one business day. Wrong size, lifted edge, crushed box: we make it right.<br><a href='/pages/shipping-returns'>The full policy ↗</a>" },
    { k: ['guarantee', 'warranty', 'lifts', 'falls', 'stick', 'adhesive', 'peeling', 'edge'],
      a: "The 8-hour guarantee: if a patch lifts before eight hours of wear, your next box is on us. That's the whole warranty — the film either holds its edge or we replace it. If a patch isn't sticking, the usual culprit is skincare under it: the adhesive needs clean, dry, bare skin." },
    { k: ['founder', 'founders', 'robert', 'joe', 'jitsukawa', 'nguyen', 'who', 'started', 'story', 'behind'],
      a: "SKINPATCH was founded in 2026 by Robert Nguyen and Joe Jitsukawa. Robert grew up with acne and worked in the beauty industry evaluating products; Joe spent nearly two decades in front of cameras, where a surprise pimple always had perfect timing. Their common ground: taking care of yourself shouldn't be complicated.<br><a href='/pages/about-us'>The full story ↗</a>" },
    { k: ['philosophy', 'mission', 'why', 'believe', 'values', 'brand'],
      a: "Four words: Small Patch. Big Difference. Taking care of yourself shouldn't be complicated, so we make everyday self-care simpler — one patch, one job, done well.<br><a href='/pages/our-philosophy'>Our philosophy ↗</a>" },
    { k: ['next', 'roadmap', 'future', 'coming', 'new', 'breathe', 'cool', 'rest', 'protect', 'mouth', 'nasal', 'blister'],
      a: "We're building beyond pimples: Skinpatch Breathe (nasal strips), Cool (menthol patches), Rest (mouth tape, subject to safety evaluation) and Protect (blister patches) are in development — none on sale yet, and nothing ships until it passes evaluation.<br><a href='/pages/whats-next'>The roadmap ↗</a>" },
    { k: ['wholesale', 'stock', 'store', 'retail', 'bulk', 'b2b', 'carry'],
      a: "We'd love that. Retail-ready packaging, a simple line sheet, and direct support — the trade application takes a few minutes.<br><a href='/pages/wholesale'>Wholesale ↗</a>" },
    { k: ['affiliate', 'creator', 'collab', 'commission', 'partner', 'influencer', 'promote'],
      a: "The affiliate program pays 10% on tracked sales, with creator collabs alongside co-founder Joe Jitsukawa.<br><a href='/pages/affiliates'>Affiliates & collabs ↗</a>" },
    { k: ['contact', 'human', 'help', 'support', 'email', 'talk', 'person', 'order', 'problem'],
      a: "A human reads every message and replies within one business day: <a href='mailto:hello@skinpatch.co'>hello@skinpatch.co</a>, or the form on the <a href='/pages/contact'>contact page ↗</a>." },
    { k: ['press', 'media', 'interview', 'journalist', 'samples'],
      a: "Brand facts, founder bios and photography are on the press page; for interviews or editorial samples, email <a href='mailto:hello@skinpatch.co'>hello@skinpatch.co</a> with “Press” in the subject.<br><a href='/pages/press'>Press & brand ↗</a>" },
    { k: ['pop', 'squeeze', 'pick', 'picking', 'toothpaste'],
      a: "Please don't — squeezing pushes inflammation deeper and is the fastest route to a scar, and toothpaste is an irritant, not a treatment. Patch it instead: the patch drains what's ready and keeps fingers off the rest.<br><a href='/blogs/journal/get-rid-of-a-pimple-overnight'>The honest overnight guide ↗</a>" },
    { k: ['prevent', 'prevention', 'stop', 'routine', 'cure', 'acne', 'treatment'],
      a: "Straight answer: a patch treats the spot that exists — it isn't a routine and doesn't claim to prevent the next one. For recurring or severe acne, a dermatologist should set the plan. Patches are the off switch for a bad skin day, not a cure." }
  ];

  var CHIPS = [
    'How do I use it?',
    'Which patch should I pick?',
    'Will it show under makeup?',
    'Does it work on cystic acne?',
    'Shipping & returns',
    'Who makes this?'
  ];

  function hydrate(a) {
    return a
      .replace('%CARD_COMBO%', card(P.combo))
      .replace('%CARD_NIGHT%', card(P.night))
      .replace('%P_NIGHT%', P.night.price)
      .replace('%P_DAY%', P.day.price)
      .replace('%P_COMBO%', P.combo.price);
  }

  function answer(q) {
    var words = q.toLowerCase().replace(/[^a-z0-9\s]/g, ' ').split(/\s+/).filter(function (w) { return w.length > 2; });
    var best = null;
    var bestScore = 0;
    KB.forEach(function (entry) {
      var score = 0;
      words.forEach(function (w) {
        entry.k.forEach(function (key) {
          if (w === key) score += 2;
          else if (w.length > 3 && (key.indexOf(w) === 0 || w.indexOf(key) === 0)) score += 1;
        });
      });
      if (score > bestScore) { bestScore = score; best = entry; }
    });
    if (best && bestScore >= 2) return hydrate(best.a);
    return "I only answer with things that are actually true about SKINPATCH, and I don't have that one — rather than guess, ask a human: <a href='mailto:hello@skinpatch.co'>hello@skinpatch.co</a> or the <a href='/pages/contact'>contact form ↗</a>. Replies within one business day.";
  }

  function push(role, html) {
    var row = document.createElement('div');
    row.className = 'cbot__msg cbot__msg--' + role;
    row.innerHTML = html;
    log.appendChild(row);
    log.scrollTop = log.scrollHeight;
    return row;
  }

  var AI_URL = 'https://skinpatch-ai.netlify.app/api/chat';
  var history = [];

  function renderReply(text) {
    var safe = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    safe = safe.replace(/\[\[(combo|day|night)\]\]/g, function (m, key) {
      return P[key] ? card(P[key]) : '';
    });
    safe = safe.replace(/\[([^\]]{1,80})\]\((\/[^)\s]{1,120}|mailto:hello@skinpatch\.co)\)/g,
      '<a href="$2">$1</a>');
    return safe.replace(/\n/g, '<br>');
  }

  function botReply(q) {
    var typing = push('bot', '<span class="cbot__typing"><i></i><i></i><i></i></span>');
    var done = false;
    function finish(html, replyText) {
      if (done) return;
      done = true;
      typing.innerHTML = html;
      if (replyText) history.push({ role: 'assistant', content: replyText.slice(0, 600) });
      log.scrollTop = log.scrollHeight;
    }
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = setTimeout(function () {
      if (ctrl) ctrl.abort();
      finish(answer(q));
    }, 12000);
    fetch(AI_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      signal: ctrl && ctrl.signal,
      body: JSON.stringify({ messages: history.slice(-10), products: P })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (d) {
        clearTimeout(timer);
        if (d && typeof d.reply === 'string' && d.reply) finish(renderReply(d.reply), d.reply);
        else finish(answer(q));
      })
      .catch(function () {
        clearTimeout(timer);
        finish(answer(q));
      });
  }

  function ask(q) {
    push('user', q.replace(/</g, '&lt;'));
    history.push({ role: 'user', content: q.slice(0, 600) });
    botReply(q);
  }

  CHIPS.forEach(function (c) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cbot__chip';
    b.textContent = c;
    b.addEventListener('click', function () { ask(c); });
    chipsEl.appendChild(b);
  });

  var greeted = false;
  function setOpen(open) {
    root.hidden = !open;
    fab.setAttribute('aria-expanded', open ? 'true' : 'false');
    fab.classList.toggle('is-hidden', open);
    if (open) {
      if (!greeted) {
        greeted = true;
        push('bot', "Pimples happen. Questions too — ask me anything about the patches, and if I don't know, I'll say so and point you to a human.");
      }
      input.focus();
    }
  }
  fab.addEventListener('click', function () { setOpen(true); });
  root.querySelector('[data-cbot-close]').addEventListener('click', function () { setOpen(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) setOpen(false);
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var q = input.value.trim();
    if (!q) return;
    input.value = '';
    ask(q);
  });
})();


/* ================= REDESIGN (v0) ================= */
/* mobile menu */
(function () {
  var btn = document.querySelector('[data-dmenu-btn]');
  var menu = document.getElementById('mobile-menu');
  if (!btn || !menu) return;
  var iOpen = btn.querySelector('[data-dmenu-open]');
  var iClose = btn.querySelector('[data-dmenu-close]');
  var label = btn.querySelector('[data-dmenu-label]');
  function set(open) {
    menu.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (iOpen) iOpen.hidden = open;
    if (iClose) iClose.hidden = !open;
    if (label) label.textContent = open ? 'Close menu' : 'Open menu';
  }
  btn.addEventListener('click', function () { set(menu.hidden); });
  menu.addEventListener('click', function (e) { if (e.target.closest('a')) set(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) { set(false); btn.focus(); } });
  window.addEventListener('resize', function () { if (window.innerWidth >= 768 && !menu.hidden) set(false); });
})();

/* patch finder */
(function () {
  var root = document.querySelector('[data-finder]');
  if (!root) return;
  var dataEl = root.querySelector('[data-finder-data]');
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var q = function (s) { return root.querySelector(s); };
  root.addEventListener('change', function (e) {
    var r = e.target;
    if (!r.matches || !r.matches('input[name="wear-time"]')) return;
    var d = data[r.value];
    if (!d) return;
    q('[data-finder-name]').textContent = d.name;
    q('[data-finder-note]').textContent = d.note;
    q('[data-finder-cta]').textContent = 'Shop ' + d.name;
    q('[data-finder-price]').textContent = d.price;
    q('[data-finder-link]').setAttribute('href', d.url);
    q('[data-finder-img]').setAttribute('src', d.img);
  });
})();
